module.exports = __webpack_public_path__ + "img/home-banner.de5a653c.png";